import {
  Box,
  Flex,
  FormNumberInput,
  MoreMenuIconButton,
  styled,
  TableCell,
  TableRow,
  type TableRowProps,
  DeleteOutlineIcon,
} from '@shared/components';
import { randomUUID } from '@shared/utils';

import { type QBankStructureSettingSectionTableData } from '../qbank-structure-table';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderColor: theme.palette.grey[300],
  borderRight: `1px solid ${theme.palette.grey[300]}`,
  minHeight: '48px',
  ...theme.typography.body2Semibold,
}));

interface ChapterTableRowProps extends TableRowProps {
  data: QBankStructureSettingSectionTableData;
  expanded?: boolean;
  onExpand?: (id: string) => void;
  handleDeleteMenu: (id: string) => void;
}

function renderBox(totalBoxes: number) {
  return (
    <>
      {Array.from({ length: totalBoxes }).map(() => (
        <Box
          key={randomUUID()}
          sx={{
            minWidth: '48px',
            minHeight: '48px',
            mt: '-1px',
            borderRight: (theme) => `1px solid ${theme.palette.grey[300]}`,
          }}
        />
      ))}
    </>
  );
}

export default function ChapterTableRow(props: Readonly<ChapterTableRowProps>) {
  const { data, handleDeleteMenu, ...restProps } = props;
  const { id, qSourceName } = data;
  return (
    <TableRow
      {...restProps}
      sx={{
        border: 'none',
        ':last-child': {
          borderRight: 'none',
          td: {
            borderBottom: 'none',
          },
        },
        ...restProps.sx,
      }}
    >
      <StyledTableCell
        sx={{
          p: (theme) => theme.spacing(0),
          borderBottom: 'none',
        }}
      >
        <Flex
          sx={{
            minHeight: '48px',
          }}
        >
          {renderBox(1)}
          <Flex
            sx={{
              alignItems: 'center',
              borderBottom: '1px solid',
              width: '100%',
              borderColor: (theme) => theme.palette.grey[300],
              p: (theme) => theme.spacing(0),
            }}
          >
            <Flex
              sx={(theme) => ({
                flex: 1,
                p: theme.spacing(3, 3),
              })}
            >
              {data.levelName}
            </Flex>
          </Flex>
        </Flex>
      </StyledTableCell>
      <StyledTableCell align='center'>{qSourceName}</StyledTableCell>
      <StyledTableCell align='center'>
        <FormNumberInput
          name={`chapterQuestionDistribution.${id}`}
          placeholder='0'
          sx={(theme) => ({
            '.MuiInputBase-input': {
              textAlign: 'center',
              p: theme.spacing(1, 3),
              minHeight: '32px',
            },
          })}
        />
      </StyledTableCell>
      <StyledTableCell
        align='center'
        sx={{
          borderRight: 'none',
        }}
      >
        <MoreMenuIconButton
          options={[
            {
              label: 'Remove',
              icon: <DeleteOutlineIcon sx={(theme) => ({ color: theme.palette.error.main })} />,
              sx: (theme) => ({ color: theme.palette.error.main }),
              onClick: () => handleDeleteMenu(id),
            },
          ]}
        />
      </StyledTableCell>
    </TableRow>
  );
}
